import Models from "@models";
import { defaultInstance } from "./instances";

export const fetch = async (id: number): Promise<any> =>
  await defaultInstance.get<Models.Region>(`/regions/${id}`);

export const fetchAll = async (): Promise<any> =>
  await defaultInstance.get<Models.Region[]>(`/regions`);
